<div class="details">
    <table mat-table [dataSource]="details" class="mat-elevation-z0">
        <ng-container *ngFor="let column of columnDefinitions" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef class="text-center">
                {{ column }}
            </th>
            <td mat-cell *matCellDef="let element" class="text-center">
                {{ element[column] }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnDefinitions"></tr>
        <tr mat-row *matRowDef="let row; columns: columnDefinitions"></tr>
    </table>

    <ng-container *ngIf="exportData">
        <button
            [id]="'button_graphic-details_Detalhes'"
            mat-raised-button
            class="center"
            color="primary"
            (click)="requestDataExport()"
        >
            {{ "GRAPHIC_REPORT.ACTIONS.EXPORT.TITLE" | translate }}
        </button>

        <span class="hint">{{ "GRAPHIC_REPORT.ACTIONS.EXPORT.HINT" | translate }}</span>
    </ng-container>
</div>
